import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import Link from '@stories/Components/Link/Link';
import styled from 'styled-components';
const Container = styled.section `
  display: block;
`;
const Section = styled.div `
  display: block;
  margin: 0 0 16px;
`;
const Title = styled.h2 `
  display: block;
  ${fonts.brown.regular};
  font-size: ${fluid(16, 18)};
  letter-spacing: normal;
  line-height: 24px;
  margin: 0 0 8px;
  text-transform: uppercase;

  @media ${from(Device.TabletLarge)} {
    letter-spacing: 0.05em;
    margin: 0 0 16px;
  }
`;
const Content = styled.div `
  display: block;
  ${fonts.brown.light};
  font-size: ${fluid(16, 24)};
  line-height: ${fluid(24, 32)};
`;
const List = styled.ul `
  display: block;
`;
const Item = styled.li `
  display: block;
`;
const StyledLink = styled(Link) `
  display: flex;
  align-items: center;
  color: currentColor;
  ${fonts.brown.light};
  font-size: ${fluid(16, 24)};
  line-height: ${fluid(24, 32)};
  margin: 0 0 16px;
  text-decoration: none;
  text-underline-position: under;

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
const Icon = styled.span `
  display: inline-block;
  height: 9px;
  margin: 0 8px 0 0;
  width: 9px;

  @media ${from(Device.TabletLarge)} {
    height: 14px;
    width: 14px;
  }
`;
const Text = styled.span `
  display: inline-block;
`;
const SupportingText = styled.div `
  ${fonts.brown.light};
  font-size: ${fluid(14, 18)};
  line-height: ${fluid(22, 26)};
  margin: -4px 0 12px;
  max-width: 480px;
`;
export default {
    Container,
    Content,
    Icon,
    Item,
    Link: StyledLink,
    List,
    Section,
    Text,
    SupportingText,
    Title,
};
